import { useEffect, useState } from "react";
import AgentData from '../components/tables/AgentData'
import DashboardLayout from '../Layout/Index'
import { AddAgentDrawer } from '../Modals/AddAgentDrawer'
import { AgentDetails } from '../Modals/AgentDetails'
import { fetchAgents } from "../redux/slices/agentSlice";
import { useDispatch, useSelector } from "react-redux";

const DeliveryAgent = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const itemsPerPage = 10;
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");

  const [currentPage, setCurrentPage] = useState(1); 
  const [totalRecord, setTotalRecord] = useState(0); 
  const [categoryId, setCategoryId] = useState(null)

  const agents = useSelector((state) => state?.agent);
  
  useEffect(() =>{
    dispatch(
      fetchAgents({
      searchText: searchTerm,
      pageSize: itemsPerPage,
      pageNumber: currentPage,
    }))
  }, [dispatch, searchTerm, currentPage, categoryId]);

  useEffect(() => {
    if(agents){
      setTotalRecord(agents?.agents?.totalRecord);
    }
  },[agents]);

  const data = agents?.agents?.data;


  const handleRowClick = (item) => {
    setSelectedItem(item);
    setIsDrawerOpen(true); 
  };


  return (
    <DashboardLayout>
      <div className="px-6 sm:px-8 py-10 h-full w-full mt-16">
        <div className=" p-5 bg-white rounded-lg shadow-lg">
          <div className="flex flex-col sm:flex-row md:items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-[#FF0000] pb-5 md:pb-2">Manage Delivery Agents</h1>
              <p className="text-sm lg:max-w-[44rem] text-[#0A0A0A]/80">
              Oversee your delivery team effortlessly. Add new agents, assign orders, and monitor performance to ensure each delivery is efficient and every customer is happy.
              </p>
            </div>
            <AddAgentDrawer />
          </div>
       </div>
        <AgentData
          onRowClick={handleRowClick} 
          searchTerm={searchTerm} 
          data={data} 
          itemsPerPage={itemsPerPage} 
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          isLoading={agents?.loading}
          totalRecord={totalRecord}
        />
        <AgentDetails 
          isOpen={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          id={selectedItem}
        />
      </div>
    </DashboardLayout>
  )
}
export default DeliveryAgent